import { defineComponent as _defineComponent } from 'vue'
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {
  computed, onMounted, reactive, ref,
} from 'vue';
import { useRouter } from 'vue-router/composables';

import VoucherUserIdentificationForm from '@/components/VoucherUserIdentificationForm.vue';
import ApiErrorMessage from '@/components/widgets/ApiErrorMessage.vue';
import voucherCode from '@/vuelidate/validators/voucherCode';
import GoogleRecaptcha, { GoogleRecaptchaModel } from '~component/GoogleRecaptcha.vue';
import SubmitButton from '~component/SubmitButton.vue';
import VoucherInput from '~component/VoucherInput.vue';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterVoucherCode',
  setup(__props) {

const getters = store?.getters;

const router = useRouter();

const form = reactive({
  code: '',
  captchaResponse: '',
});

const rules = {
  code: {
    required,
    voucherCode,
  },
};

const errors = ref([]);
const voucherNeedsUserIdentification = computed(() => errors.value.some((error) => error.code === 'VCRx52'));

const submitted = ref(false);
const v$ = useVuelidate(rules, form);
const googleRecaptcha = ref(null as unknown as GoogleRecaptchaModel);
const voucherCategoryId = computed(() => getters.getVoucherCategoryIdFromConfig);

store.dispatch('removeVoucher');
store.dispatch('removeVoucherToken');

function redirectToShopWall() {
  return router.push({ name: 'shops' });
}

function handleSubmit(): void {
  if (!submitted.value) {
    v$.value.$touch();

    if (googleRecaptcha.value?.validate?.() && !v$.value.$invalid) {
      form.captchaResponse = googleRecaptcha?.value?.getResponse?.() || '';

      submitted.value = true;
      store
        .dispatch('fetchVoucherToken', {
          code: form.code,
          voucherCategory: voucherCategoryId.value,
          captcha: form.captchaResponse,
        })
        .then(() => {
          // trigger callback
          redirectToShopWall().then(() => {
            submitted.value = false;
          });
        })
        .catch((e) => {
          submitted.value = false;
          errors.value = e.response.data.errors;
          googleRecaptcha?.value?.reset?.();
        });
    }
  }
}

onMounted(() => {
  const hash = window.location?.hash?.split?.('#')?.[1];
  const hashCode = voucherCode(hash) ? hash : '';
  const debugCode = process?.env?.VUE_APP_DEBUG_CODE;

  form.code = hashCode || debugCode || '';
});

return { __sfc: true,getters, router, form, rules, errors, voucherNeedsUserIdentification, submitted, v$, googleRecaptcha, voucherCategoryId, redirectToShopWall, handleSubmit, VoucherUserIdentificationForm, ApiErrorMessage, GoogleRecaptcha, SubmitButton, VoucherInput }
}

})